export default "__VITE_ASSET__Ded7JBEu__"